module.exports = __webpack_public_path__ + "static/media/mpl-logo.2a517cdd.png";